import { z } from 'zod';

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale } from './locale.js';

/** A name in every supported language (D31): `{ uk: '…', en: '…' }`. */
export type LocalizedName = Record<Locale, string>;

/** Requires every key in SUPPORTED_LOCALES, so adding a language flags missing translations. */
export const localizedNameSchema = z.record(z.enum(SUPPORTED_LOCALES), z.string().trim().min(1));

/** The name in `locale`, falling back to the default locale. */
export function pickLocalized(name: LocalizedName, locale: Locale): string {
	return name[locale] || name[DEFAULT_LOCALE];
}
